import Scroll from './common/scroll';
import Accordion from './common/accordion.es6';

const scroll = new Scroll();
const accordion = new Accordion(scroll);